document.addEventListener('DOMContentLoaded', function() {
    const burger = document.querySelector('.krg-burger');
    const mobileMenu = document.getElementById('krgMobileMenu');
    const header = document.querySelector('.site-header');

    if (burger && mobileMenu) {
        const newBurger = burger.cloneNode(true);
        burger.parentNode.replaceChild(newBurger, burger);
        
        newBurger.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            if (mobileMenu.classList.contains('active')) {
                mobileMenu.classList.remove('active');
                newBurger.classList.remove('active');
                newBurger.classList.remove('close-btn');
                mobileMenu.setAttribute('aria-hidden', 'true');
                document.documentElement.classList.remove('overflow-hidden');
                document.body.classList.remove('overflow-hidden');
            } else {
                mobileMenu.classList.add('active');
                newBurger.classList.add('active');
                newBurger.classList.add('close-btn');
                mobileMenu.setAttribute('aria-hidden', 'false');
                document.documentElement.classList.add('overflow-hidden');
                document.body.classList.add('overflow-hidden');
            }
        });

        mobileMenu.addEventListener('click', function(e) {
            if (e.target === mobileMenu) {
                mobileMenu.classList.remove('active');
                newBurger.classList.remove('active');
                newBurger.classList.remove('close-btn');
                mobileMenu.setAttribute('aria-hidden', 'true');
                document.documentElement.classList.remove('overflow-hidden');
                document.body.classList.remove('overflow-hidden');
            }
        });

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && mobileMenu.classList.contains('active')) {
                mobileMenu.classList.remove('active');
                newBurger.classList.remove('active');
                newBurger.classList.remove('close-btn');
                mobileMenu.setAttribute('aria-hidden', 'true');
                document.documentElement.classList.remove('overflow-hidden');
                document.body.classList.remove('overflow-hidden');
            }
        });
    }

    const searchBtn = document.getElementById('krgOpenSearchModal');
    const searchModal = document.getElementById('krgSearchModal');
    const closeSearchBtn = document.getElementById('krgCloseSearchModal');

    if (searchBtn && searchModal && closeSearchBtn) {
        searchBtn.addEventListener('click', function(e) {
            e.preventDefault();
            console.log('Search button clicked');
            searchModal.classList.add('active');
            searchModal.setAttribute('aria-hidden', 'false');
            document.documentElement.classList.add('overflow-hidden');
            document.body.classList.add('overflow-hidden');
        });

        closeSearchBtn.addEventListener('click', function() {
            searchModal.classList.remove('active');
            searchModal.setAttribute('aria-hidden', 'true');
            document.documentElement.classList.remove('overflow-hidden');
            document.body.classList.remove('overflow-hidden');
        });

        searchModal.addEventListener('click', function(e) {
            if (e.target === searchModal) {
                searchModal.classList.remove('active');
                searchModal.setAttribute('aria-hidden', 'true');
                document.documentElement.classList.remove('overflow-hidden');
                document.body.classList.remove('overflow-hidden');
            }
        });
    }

    if (header && header.classList.contains('header-sticky')) { 
        const headerIsAbsolute = header.classList.contains('header-absolute');
        
        let lastScroll = 0;
        let isHeaderVisible = true;
        
        header.style.transition = 'transform 0.5s ease';
        
        function isMobile() {
            return window.innerWidth < 768;
        }
        
        function handleStickyScroll() {
            if (isMobile()) {
                return;
            }
            
            const currentScroll = window.pageYOffset;
            const scrollDirection = currentScroll > lastScroll ? 'down' : 'up';
            
            if (currentScroll <= 100) {
                header.classList.remove('header-scrolled');
                if (headerIsAbsolute) {
                    header.classList.add('header-absolute');
                }
                isHeaderVisible = true;
            }
            else if (currentScroll > 100 && scrollDirection === 'down' && isHeaderVisible) {
                header.classList.remove('header-scrolled');
                if (headerIsAbsolute) {
                    header.classList.add('header-absolute');
                }
                isHeaderVisible = false;
            }
            else if (scrollDirection === 'up' && !isHeaderVisible) {
                header.classList.add('header-scrolled');
                if (headerIsAbsolute) {
                    header.classList.remove('header-absolute');
                }
                isHeaderVisible = true;
            }
            
            lastScroll = currentScroll;
        }
        
        window.addEventListener('scroll', handleStickyScroll);
        
        window.addEventListener('resize', function() {
            if (isMobile()) {
                header.classList.remove('header-scrolled');
                if (headerIsAbsolute) {
                    header.classList.add('header-absolute');
                }
                isHeaderVisible = true;
                lastScroll = window.pageYOffset;
            }
        });
    }
});